export const PDF_LAYOUT = {
  SPACING: {
    XXSMALL: 3,
    XSMALL: 4,
    SMALL: 5,
    MEDIUM: 8,
    LARGE: 10,
    XLARGE: 15,
    XXLARGE: 20,
    XXXLARGE: 30,
  },

  PADDING: {
    PAGE: 30,
    CONTENT: 10,
    CONTAINER: 12,
  },

  MARGIN: {
    PAGE: '10px 10px 10px',
    SECTION: {
      BOTTOM: 15,
    },
  },

  BORDER_RADIUS: {
    SMALL: 4,
  },

  BORDER_WIDTH: {
    THIN: 0.5,
    NORMAL: 1,
  },

  DIMENSIONS: {
    IMAGE_HEIGHT: '60vh',
    MAX_IMAGE_HEIGHT: '450px',
  },
}
